export default {"src":"/_next/static/media/like-filled.463a917a.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};